export default __webpack_public_path__ + "static/media/home_filter_avatar.2aa2b8c7.svg";